const body = qs('body')

/* Swiper Initialiser */
const swiperContainerP = document.getElementsByClassName('carousel_product')
for (var i = 0; i < swiperContainerP.length; i++) {
	swiperContainerP[i].classList.add('swiperP' + i)

	const swiperPage = swiperContainerP[i].querySelector('.swiper-pagination')

	if (swiperPage) {
		swiperPage.classList.add('pageP' + i)
	}

	var mySwiperP = new Swiper('.swiperP' + i, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 1,
		speed: 300,
		centeredSlides: true,
		pagination: {
			el: '.pageP' + i,
			clickable: true
		}
	})
}

/* Details Animator */

const detailLinks = qsa('details a')

detailLinks.forEach((link) => {
	link.addEventListener('click', (e) => {
		e.stopPropagation()
	})
})
const details = document.querySelectorAll('details')

/* Lazy Load Initialiser */
var lazyLoadInstance = new LazyLoad({})

/* Liquid Ajax Cart */

liquidAjaxCart.subscribeToCartAjaxRequests((state, subscribeToResult) => {
	if (state.requestType == 'add') {
		const form = state.info.initiator
		let btnInner = ''

		const btn = form.querySelector('button[type="submit"]')
		if (btn) {
			btnInner = btn.innerHTML
			btn.innerHTML = 'Adding'
		}

		subscribeToResult((state) => {
			const btn = form.querySelector('button[type="submit"]')
			if (state.responseData.ok) {
				cartOpen()
			}

			if (btn) {
				setTimeout(() => {
					btn.innerHTML = btnInner
				}, 300)
			}
		})
	}
})

/* enterview */

const reveals = qsa('.reveal')

if (reveals.length > 0) {
	enterView({
		selector: '.reveal',
		enter: (el, i) => {
			el.classList.add('entered')
		},
		exit: (el) => {
			el.classList.remove('entered')
		},
		offset: 0.1
	})
}

/* Load video on enter */

const llVideos = document.querySelectorAll('video.lazy')

if (llVideos.length > 0) {
	enterView({
		selector: '.video-ll',
		enter: function (el) {
			el.load()
			el.play()
		},
		offset: 0.1
	})
}

// Nav Active State

const navMenuButtons = qsa('[data-menu-button]')

let activeMenu = null
let activeBtn = null

const openMenu = (btn, moveFocus = false) => {
	const group = btn.dataset.menuButton
	const el = qs(`[data-parent-menu="${group}"]`)
	if (!el) return

	if (activeMenu && activeMenu !== el) {
		closeMenu()
	}

	btn.classList.add('active')
	el.classList.add('active')

	btn.setAttribute('aria-expanded', 'true')
	el.removeAttribute('inert')

	activeMenu = el
	activeBtn = btn

	if (moveFocus) {
		const firstFocusable = el.querySelector(
			'a, button, [tabindex]:not([tabindex="-1"])'
		)
		firstFocusable?.focus()
	}
}

const closeMenu = () => {
	if (!activeMenu || !activeBtn) return

	activeMenu.classList.remove('active')
	activeMenu.setAttribute('inert', '')

	activeBtn.classList.remove('active')
	activeBtn.setAttribute('aria-expanded', 'false')

	activeMenu = null
	activeBtn = null
}

document.addEventListener('keydown', (e) => {
	if (e.key === 'Escape' && activeMenu) {
		closeMenu()
		activeBtn?.focus()
	}
})

document.addEventListener('click', (e) => {
	if (!activeMenu) return

	if (!activeMenu.contains(e.target) && !activeBtn.contains(e.target)) {
		closeMenu()
	}
})

document.addEventListener('focusin', (e) => {
	if (!activeMenu) return

	const isInside = activeMenu.contains(e.target) || activeBtn.contains(e.target)

	if (!isInside) {
		closeMenu()
	}
})

navMenuButtons.forEach((btn) => {
	btn.addEventListener('mouseenter', () => {
		openMenu(btn)
	})

	btn.addEventListener('focus', () => {
		openMenu(btn)
	})

	btn.addEventListener('keydown', (e) => {
		if (e.key === 'ArrowDown') {
			e.preventDefault()

			const group = btn.dataset.menuButton
			const el = qs(`[data-parent-menu="${group}"]`)

			openMenu(btn)

			const firstFocusable = el?.querySelector(
				'a, button, [tabindex]:not([tabindex="-1"])'
			)

			firstFocusable?.focus()
		}
	})
})

const navMenuItems = qsa('[data-parent-menu]')

navMenuItems.forEach((item) => {
	const group = item.dataset.parentMenu
	const bg = qs('[data-nav-bg]', item)

	if (bg) {
		bg.addEventListener('mouseenter', () => {
			if (item.classList.contains('active')) {
				closeMenu()
			}
		})

		bg.addEventListener('click', () => {
			if (item.classList.contains('active')) {
				closeMenu()
			}
		})
	}
})

/* Search */

const searchModalTriggers = qsa('[data-search-trigger]')
const searchModal = qs('#searchModal')
const searchInput = qs('input', searchModal)

searchModalTriggers.forEach((trigger) => {
	trigger.addEventListener('click', (e) => {
		e.preventDefault()
		searchModal.classList.toggle('active')

		const active = searchModal.classList.contains('active')

		if (active) {
			searchModalTriggers.forEach((trigger) => {
				trigger.setAttribute('aria-expanded', true)
			})
			setTimeout(() => {
				searchInput.focus()
			}, 500)
		} else {
			searchModalTriggers.forEach((trigger) => {
				trigger.setAttribute('aria-expanded', false)
			})
		}
	})
})

const featuredProducts = qsa('[data-featured-product-swiper]')
featuredProducts.forEach((sw) => {
	const swiper = new Swiper(sw, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		slidesPerView: 2.15,
		speed: 400,
		spaceBetween: 8
	})
})

const featuredArticles = qsa('[data-featured-articles-swiper]')

featuredArticles.forEach((sw) => {
	const el = qs('.swiper-container', sw)
	const prev = qs('[data-swiper-pagination-previous]', sw)
	const next = qs('[data-swiper-pagination-next]', sw)

	const swiper = new Swiper(el, {
		direction: 'horizontal',
		loop: false,
		slidesPerView: 2.15,
		spaceBetween: 8,
		autoHeight: false,
		speed: 400,
		mousewheel: {
			forceToAxis: true
		},
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 12
			}
		},
		navigation: {
			nextEl: next,
			prevEl: prev
		}
	})
})
const collectionListCollections = qsa('[data-collection-list-swiper]')

collectionListCollections.forEach((sw) => {
	const el = qs('.swiper-container', sw)
	const prev = qs('[data-swiper-pagination-previous]', sw)
	const next = qs('[data-swiper-pagination-next]', sw)

	const swiper = new Swiper(el, {
		direction: 'horizontal',
		loop: false,
		slidesPerView: 2.15,
		autoHeight: false,
		spaceBetween: 8,
		mousewheel: {
			forceToAxis: true
		},
		speed: 400,
		breakpoints: {
			768: {
				slidesPerView: 5,
				spaceBetween: 12
			}
		},
		navigation: {
			nextEl: next,
			prevEl: prev
		}
	})
})

const header = qs('#header')
const mobileNavToggles = qsa('[data-mobile-nav-toggle]')

mobileNavToggles.forEach((toggle) => {
	toggle.addEventListener('click', () => {
		header.classList.toggle('active')
	})
})

const level1Wrapper = qs(`#mobileNavLevel1`)
const level2Toggles = qsa(`[data-level-two-toggle]`)
const level2Containers = qsa(`[data-level-two]`)

level2Toggles.forEach((toggle) => {
	toggle.addEventListener('click', () => {
		const group = toggle.dataset.levelTwoToggle

		const nav = qs(`[data-level-two="${group}"]`)

		if (nav) {
			toggleActive(nav)
			toggleActive(level1Wrapper)
		}
	})
})

const navBackBtns = qsa('[data-mobile-nav-back-btn]')

navBackBtns.forEach((btn) => {
	btn.addEventListener('click', () => {
		toggleActive(`[data-level-two].active`)
		toggleActive(level1Wrapper)
	})
})

/* Collection Page */

const collectionSortOptions = qsa('[data-collection-sort]')

collectionSortOptions.forEach((option) => {
	option.addEventListener('click', () => {
		const sort = option.dataset.collectionSort
		const url = new URL(window.location)
		const params = new URLSearchParams(url.search)
		params.set('sort_by', sort)
		url.search = params.toString()
		window.location.href = url.toString()
	})
})

const productsUsedTriggers = qsa(`[data-products-used-toggle]`)
const productsUsedModal = qs('#productsUsed')

productsUsedTriggers.forEach((trig) => {
	trig.addEventListener('click', () => {
		toggleActive(productsUsedModal)
	})
})

const teamMembers = qsa('[data-member-tag]')
const teamFilters = qsa('[data-filter-tag]')
let activeTags = []

teamFilters.forEach((filter) => {
	filter.addEventListener('click', (e) => {
		toggleActive(filter)
		const tag = filter.dataset.filterTag

		if (activeTags.includes(tag)) {
			activeTags = activeTags.filter((t) => t != tag)
		} else {
			activeTags.push(tag)
		}

		updateFilters(activeTags, teamMembers)

		teamMembers.forEach((member) => {
			if (activeTags.length == 0) {
				member.classList.add('active')
				return
			}
			const memberTag = member.dataset.memberTag
			if (activeTags.includes(memberTag)) {
				member.classList.add('active')
			} else {
				member.classList.remove('active')
			}
		})
	})
})

const updateFilters = (tags, members) => {
	const state = Flip.getState(teamMembers)

	teamMembers.forEach((member) => {
		const tag = member.dataset.memberTag
		if (tags.includes(tag)) {
			member.classList.add('active')
		} else {
			member.classList.remove('active')
		}
	})

	Flip.from(state, {
		duration: 0.5,
		ease: 'power3.inOut',
		stagger: 0,
		absolute: true,
		onEnter: (elements) =>
			gsap.fromTo(
				elements,
				{
					scale: 0
				},
				{
					scale: 1,
					duration: 1
				}
			),
		onLeave: (elements) =>
			gsap.to(elements, {
				scale: 0,
				duration: 1
			}),
		onComplete: () => {
			members.forEach((item) => {
				const tag = item.dataset.memberTag

				if (tags.length == 0) {
					gsap.to(item, {
						opacity: 1,
						duration: 0.3
					})
					return
				}
				if (tags.includes(tag)) {
					gsap.to(item, {
						opacity: 1,
						duration: 0.3
					})
				} else {
					gsap.to(item, {
						opacity: 0,
						duration: 0.3
					})
				}
			})
		}
	})
}

const pageReadMoreBtn = qs('#readMoreBtn')
const pageReadMore = qs('#pageIntro')

if (pageReadMoreBtn && pageReadMore) {
	pageReadMoreBtn.addEventListener('click', () => {
		pageReadMore.classList.toggle('active')

		const inner = qs('#inner', pageReadMoreBtn)

		if (pageReadMore.classList.contains('active')) {
			inner.textContent = 'Read less'
		} else {
			inner.textContent = 'Read more'
		}
	})
}

//* Product Enquiry Triggers

const productEnquiryTriggers = qsa('[data-product-enquiry-trigger]')
const productEnquiry = qs('#productEnquiry')

productEnquiryTriggers.forEach((trig) => {
	trig.addEventListener('click', (e) => {
		e.preventDefault()
		productEnquiry && productEnquiry.classList.toggle('active')
		body.classList.toggle('js-product-enquiry-open')
	})
})
const cartEnquiryTriggers = qsa('[data-cart-enquiry-trigger]')
const cartEnquiry = qs('#cartEnquiry')

cartEnquiryTriggers.forEach((trig) => {
	trig.addEventListener('click', (e) => {
		e.preventDefault()
		cartEnquiry && cartEnquiry.classList.toggle('active')
	})
})

/* Product Page */
const productCarouselEl = qs('#productCarousel')
const productCarouselThumbnailsEl = qs('#productCarouselThumbnails')

const productCarouselThumbnails = new Swiper(productCarouselThumbnailsEl, {
	direction: 'horizontal',
	slidesPerView: 'auto',
	spaceBetween: 8,
	loop: true,
	spaceBetween: 5,
	watchSlidesProgress: true
})

const productCarousel = new Swiper(productCarouselEl, {
	direction: 'horizontal',
	loop: false,
	autoHeight: false,
	slidesPerView: 1,
	speed: 400,
	centeredSlides: true,
	thumbs: {
		swiper: productCarouselThumbnails
	},
	mousewheel: {
		forceToAxis: true
	},
	keyboard: {
		enabled: true,
		onlyInViewport: true
	}
})

/* Product Hero Media Swiper */

const productHeroMedia = qsa('[data-product-hero-media]')

productHeroMedia.forEach((module) => {
	const swiperContainer = qs('.swiper-container', module)
	const pagination = qs('.product-hero-media__pagination', module)
	const nextEl = qs('[data-swiper-pagination-next]')
	const prevEl = qs('[data-swiper-pagination-previous]')
	const swiper = new Swiper(swiperContainer, {
		direction: 'horizontal',
		loop: false,
		autoHeight: false,
		pagination: {
			el: pagination,
			type: 'progressbar'
		},
		slidesPerView: 'auto',
		speed: 400,
		mousewheel: {
			forceToAxis: true
		},
		navigation: {
			nextEl,
			prevEl
		}
		// keyboard: {
		// 	enabled: true,
		// 	onlyInViewport: true
		// }
	})
})

/* Form Controllers */

function formToJSON(elements) {
	return [].reduce.call(
		elements,
		(data, element) => {
			data[element.name] = element.value
			return data
		},
		{}
	)
}

// Get Shopify Friendly URL String
function getUrlString(data) {
	var urlParameters = Object.entries(data)
		.map(function (e) {
			return e.join('=')
		})
		.join('&')

	return urlParameters
}

document.addEventListener('DOMContentLoaded', (e) => {
	const _form = window.location.hash.slice(1)

	const formWrapper = qs(`[data-form-wrapper="${_form}"]`)

	if (formWrapper && !window.location.href.includes('challenge')) {
		formWrapper.classList.add('active')
	}
})

/* Brands Section */

const brandListItems = qsa('[data-brand-item-title]')
const brandListWrapper = qs('[data-brand-list-wrapper]')

brandListItems.forEach((item) => {
	item.addEventListener('mouseenter', (e) => {
		handleBrandItem(item)
	})
})

if (window.innerWidth <= 768 && brandListItems.length > 0) {
	let index = 0

	setInterval(() => {
		if (index == brandListItems.length) {
			index = 0
		} else {
			index++
		}

		const activeTitle = qs('[data-brand-item-title].active')
		const activeMedia = qs('[data-brand-item-media].active')

		const titleItem = brandListItems[index]
		const title = titleItem.dataset.brandItemTitle

		activeTitle && activeTitle.classList.remove('active')
		activeMedia && activeMedia.classList.remove('active')

		const media = qs(`[data-brand-item-media="${title}"]`)
		if (media) {
			media.classList.add('active')
		}
		titleItem.classList.add('active')
	}, 2000)
}

function handleBrandItem(item) {
	const title = item.dataset.brandItemTitle

	const oldTitle = qs('[data-brand-item-title].active')

	const media = qs(`[data-brand-item-media="${title}"]`)
	if (!media) {
		return
	}
	const oldMedia = qs(`[data-brand-item-media].active`)

	if (oldMedia) {
		oldMedia.classList.remove('active')
	}
	if (oldTitle) {
		oldTitle.classList.remove('active')
	}
	item.classList.add('active')
	media.classList.add('active')
}

const newsletterModalToggles = qsa('[data-newsletter-modal-trigger]')
const newsletterModal = qs('#newsletterPopup')

newsletterModalToggles.forEach((toggle) => {
	toggle.addEventListener('click', (e) => {
		e.preventDefault()
		newsletterModal.classList.toggle('active')
	})
})

//Mobile Collection Filters

const collectionFiltersBtn = qs('#collectionFilterBtn')
const collectionFilters = qs('#collectionFilters')

collectionFiltersBtn &&
	collectionFiltersBtn.addEventListener('click', () => {
		collectionFilters && collectionFilters.classList.toggle('active')
	})

const forms = document.querySelectorAll('[data-form-controller]')

Array.from(forms).forEach((form) => {
	form.addEventListener('submit', async (evt) => {
		evt.preventDefault()

		const botpoisonKey = form.dataset.botpoisonKey
		const botpoison = new Botpoison({
			publicKey: botpoisonKey
		})

		const url = form.action
		const submitBtn = form.querySelector('button[type="submit"]')

		let formData = new FormData(form)
		const formDataAsJSON = {}
		formData.forEach((value, key) => (formDataAsJSON[key] = value))
		submitBtn.textContent = 'Submitting'
		submitBtn.disabled = true

		if (botpoisonKey) {
			const { solution } = await botpoison.challenge()
			formDataAsJSON._botpoison = solution
		}

		const options = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Accept: 'application/json'
			},
			body: JSON.stringify(formDataAsJSON)
		}

		const res = await fetch(url, options)
			.then((res) => res.text())
			.catch((err) => {
				submitBtn.textContent = 'There has been an error, please refresh'
				console.error('this is the error', err)
			})
			.finally(() => {
				submitBtn.textContent = 'Thanks for your submission'

				setTimeout(() => {
					submitBtn.textContent = 'Submit'
					submitBtn.disabled = false
					form.reset()
				}, 5000)
			})
	})
})

const warrantyForms = qsa('[data-warranty-form]')

warrantyForms.forEach((form) => {
	const brandInput = qs('#warrantyBrand', form)
	const hiddenGroups = qsa('[data-hidden-group]')
	const brandGroups = qsa('[data-brand-group]')

	brandInput.addEventListener('change', (e) => {
		const brand = e.target.value
		hiddenGroups.forEach((group) => group.classList.remove('hidden'))

		brandGroups.forEach((group) => {
			const input = qs('input, select', group)
			const required = group.dataset.required
			const name = group.dataset.name
			if (group.dataset.brandGroup == brand) {
				group.classList.remove('hidden')
				if (input) {
					input.name = name
					input.setAttribute('required', '')
				}
			} else {
				group.classList.add('hidden')
				if (input) {
					input.name = ''
					input.removeAttribute('required')
				}
			}
		})
	})

	form.addEventListener('reset', () => {
		hiddenGroups.forEach((group) => group.classList.add('hidden'))
		brandGroups.forEach((group) => group.classList.add('hidden'))
	})
})

const productFileInputs = qsa('[data-file-name]')
const productFileDownloadButton = qs('#fileDownloadButton')
let productFileCount = 0

productFileInputs.forEach((input) => {
	input.addEventListener('change', (e) => handleInputChange)
})

const handleInputChange = () => {
	const newCount = productFileInputs.filter((_input) => _input.checked).length

	productFileCount = newCount

	if (productFileCount == 0) {
		productFileDownloadButton.classList.add('hidden')
	} else {
		productFileDownloadButton.classList.remove('hidden')
		productFileDownloadButton.textContent = `Download ${productFileCount == 1 ? '1 file' : `${productFileCount} files`}`
	}
}

productFileDownloadButton.addEventListener('click', (e) => {
	e.preventDefault()

	const files = qsa('[data-file-name]:checked')

	files.forEach((file) => {
		const url = file.value
		const name = file.getAttribute('data-file-name')
		triggerDownload(url, name)
	})
	setTimeout(() => {
		files.forEach((file) => (file.checked = false))
		productFileCount = 0
		productFileDownloadButton.classList.add('hidden')
	}, 1000)
})

const triggerDownload = (url, name) => {
	const link = document.createElement('a')
	link.href = url

	link.setAttribute('download', name)
	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)
}

const productFilesAccordions = qsa('[data-file-accordion]')

productFilesAccordions.forEach((accordion) => {
	const selectBtn = qs('[data-file-select-button]', accordion)
	const inputs = qsa('input[type="checkbox"]', accordion)
	const event = new Event('change', { bubbles: true })

	selectBtn.addEventListener('click', (e) => {
		e.preventDefault()
		e.stopPropagation()

		inputs.forEach((input) => {
			input.checked = !input.checked
		})
		handleInputChange()
	})
})
